import { SparklesIcon } from 'lucide-react';

import type { StoreItem } from '../types/get-store-items';
import { StoreItemGridCard } from './store-item-grid-card';

interface StoreHighlightsProps {
  items: StoreItem[];
  onItemClick: (item: StoreItem) => void;
  /** Selo da promoção por quantidade do produto (PRAT-184), ou null. */
  quantityPromotionLabelFor?: (item: StoreItem) => string | null;
  /** PRAT-187: "A partir de" do atacado, ou null. */
  wholesaleFromFor?: (item: StoreItem) => number | null;
}

/** Carrossel horizontal de destaques no topo do cardápio. */
export function StoreHighlights({
  items,
  onItemClick,
  quantityPromotionLabelFor,
  wholesaleFromFor,
}: StoreHighlightsProps) {
  // Com menos de 3 não é vitrine: os produtos já aparecem nas categorias.
  if (items.length < 3) return null;

  return (
    <section aria-label="Destaques" className="flex flex-col gap-3 mb-4">
      <h2 className="flex items-center gap-1.5 text-base sm:text-lg font-bold text-night">
        <SparklesIcon className="size-4 text-primary" aria-hidden />
        Destaques
      </h2>
      <div className="-mx-4 flex gap-3 overflow-x-auto px-4 pb-1 hide-scrollbar sm:-mx-5 sm:px-5">
        {items.map(item => (
          <div key={item.id} className="w-36 shrink-0 sm:w-44">
            <StoreItemGridCard
              item={item}
              onItemClick={onItemClick}
              quantityPromotionLabel={quantityPromotionLabelFor?.(item) ?? null}
              wholesaleFrom={wholesaleFromFor?.(item) ?? null}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
